// import enterpriseShopList from '../components/enterpriseShop/enterpriseShopList.vue'
// import viewEnterpriseShop from '../components/enterpriseShop/viewEnterpriseShop.vue'

export default [
    {
        path: 'enterpriseShop/enterpriseShopList',
        component: resolve => require(['@/components/enterpriseShop/enterpriseShopList'],resolve),
        name:"EnterpriseShopList",
        meta:{
            // id:'639',
            node:'enterpriseShop',
            url:'enterpriseShopList',
        }
    },
    {
        path: 'enterpriseShop/viewEnterpriseShop',
        component: resolve => require(['@/components/enterpriseShop/viewEnterpriseShop'],resolve),
        name:"ViewEnterpriseShop",
        meta:{
            // id:'639',
            node:'enterpriseShop',
            url:'viewEnterpriseShop',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/enterpriseShop.js